import { gatewayPhone } from "../../../../gateways/gatewayPhone";
import { SmsMessage } from "../chat/types/SmsMessage";

export interface SendSmsPayload {
  to: string;
  from?: string;
  companyId?: number | string | null;
  message?: string;
  files?: File[];
}

export const sendChatSms = async (
  payload: SendSmsPayload,
): Promise<SmsMessage> => {
  if (!payload.to?.trim()) {
    throw new Error("Recipient phone number is required");
  }

  const formData = new FormData();
  formData.append("to", payload.to.trim());

  const message = payload.message?.trim();
  if (message) {
    formData.append("message", message);
  }

  payload.files?.forEach((file) => {
    formData.append("files", file, file.name);
  });

  const fromNumber = payload.from?.trim() || "";

  const { data } = await gatewayPhone.post("twilio/sms/send", formData, {
    headers: {
      ...(payload.companyId != null && { "x-company-id": String(payload.companyId) }),
    },
    params: { fromNumber },
  });

  return data;
};
